import { useContext } from "react";
import { propertiesActionTypes } from "../reducer/resume-properties-reducer";
import { ResumeContext } from "../resume-context";

function useResumePropertiesHandlers() {
    const { dispatch } = useContext( ResumeContext );
    return {
        handleChange: ( name, value ) => {
            dispatch(
                {
                    type: propertiesActionTypes.CHANGE_PROPERTY,
                    payload: {
                        name: name,
                        value: value
                    }
                }
            );
        },
        handleChangeMultiple: ( properties ) => {
            dispatch(
                {
                    type: propertiesActionTypes.CHANGE_PROPERTIES,
                    payload: properties
                }
            );
        }
    }
}

export default useResumePropertiesHandlers
